import React from 'react';
import PageSyle from '../style';
import NextBackNav from '../../../components/nextBackNav';
import RoundScreen from '../../../components/roundScreen';
import MultiHalfText from '../../../components/MultiHalfText';

export default function Page01({nextPressed, backPressed, nextSlideExzists, previousSlideExzists}) {
	let style = PageSyle();
	return (
		<div style={style.outerStyle()}>
			<MultiHalfText first='Upper Body / Core' second='Workout 03' mt={true} />
			<RoundScreen
				isNumbered={false}
				rounds={[
					[
						{
							header: '(A) Biceps / Triceps',
							value: 'Curls w / (DB)',
						},
						{
							header: 'Sets / Reps',
							value: '4 x 12',
						},
						{
							header: 'ABS / Core',
							value: 'Curls w / (DB)',
						},
						{
							header: 'Sec / Minutes',
							value: '30 secs',
						},
					],
					[
						{
							header: '(A) Biceps / Triceps',
							value: 'Tricep Kickbacks w / (DB)',
						},
						{
							header: 'Sets / Reps',
							value: '4 x 12',
						},
						{
							header: 'ABS / Core',
							value: 'Single Leg Lifts',
						},
						{
							header: 'Sec / Minutes',
							value: '30 secs (each leg)',
						},
					],
					[
						{
							header: '(A) Biceps / Triceps',
							value: 'Hammer Curls',
						},
						{
							header: 'Sets / Reps',
							value: '4 x 15',
						},
						{
							header: 'ABS / Core',
							value: '6 inches',
						},
						{
							header: 'Sec / Minutes',
							value: '1 min',
						},
					],
					[
						{
							header: '(A) Biceps / Triceps',
							value: 'Dips',
						},
						{
							header: 'Sets / Reps',
							value: '4 x 15',
						},
						{
							header: 'ABS / Core',
							value: 'Penguin Crunch',
						},
						{
							header: 'Sec / Minutes',
							value: '30 secs',
						},
					],
					[
						{
							header: '(A) Biceps / Triceps',
							value: 'Jumping Jacks',
						},
						{
							header: 'Sets / Reps',
							value: '4 x 20',
						},
						{
							header: 'ABS / Core',
							value: 'Leg Lifts',
						},
						{
							header: 'Sec / Minutes',
							value: '30 secs',
						},
					],
				]}
			/>
			<NextBackNav
				message='Ready to continue?'
				mt={true}
				nextPressed={nextPressed}
				backPressed={backPressed}
				nextSlideExzists={nextSlideExzists}
				previousSlideExzists={previousSlideExzists}
			/>
		</div>
	);
}
